<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

    <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef> Matrícula </th>
        <td mat-cell *matCellDef="let element"> {{element?.matriculaAluno}} </td>
    </ng-container>

    <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef> Nome </th>
        <td mat-cell *matCellDef="let element"> {{element?.pessoaFisica?.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="dataEntrada">
        <th mat-header-cell *matHeaderCellDef> Data de admissão </th>
        <td mat-cell *matCellDef="let element"> {{element?.dataEntrada | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="dataSugestaoDesligamento">
        <th mat-header-cell *matHeaderCellDef> Data de sugestão de desligamento</th>
        <td mat-cell *matCellDef="let element"> {{element?.dataSugestaoDesligamento | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="dataDesligamento">
        <th mat-header-cell *matHeaderCellDef> Data de desligamento</th>
        <td mat-cell *matCellDef="let element"> {{element?.dataDesligamento | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="motivoDesligamento">
        <th mat-header-cell *matHeaderCellDef> Motivo do desligamento</th>
        <td mat-cell *matCellDef="let element"> {{element?.motivoDesligamento?.motivoDesligamento}} </td>
    </ng-container>
    
    <ng-container matColumnDef="stAtivo">
        <th mat-header-cell *matHeaderCellDef> Aluno Ativo </th>
        <td mat-cell *matCellDef="let element"> {{element.stAtivo ? 'Sim' : 'Não'}} </td>
    </ng-container> 

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div [hidden]="!mostrarTabela">
    <mat-paginator [length]="numberItens" [pageSizeOptions]="[10, 20, 40, 60, 80, 100]" showFirstLastButtons
        (page)="onEventPaginate($event)"></mat-paginator>
</div>
<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
        {{msg}}
    </div>
</ng-template>